import auth from './auth'
import store from './store'
import comp from './comp'
import api from './api'

export default vue => {
  vue.use(auth)
  vue.use(store)
  vue.use(comp)
  vue.use(api)
}
